var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {}, [
    _c(
      "div",
      { staticClass: "breadcrumb-layout" },
      [
        _c(
          "el-breadcrumb",
          { attrs: { separator: "/" } },
          [
            _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
              _vm._v("首页")
            ]),
            _vm._v(" "),
            _c("el-breadcrumb-item", [_vm._v("报价单详情")])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "right",
            on: {
              click: function($event) {
                _vm.goBack()
              }
            }
          },
          [_vm._m(0)]
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("div", {}, [
      _c("div", { staticClass: "form-single" }, [
        _c("div", { staticClass: "title" }, [_vm._v("询价标题")]),
        _vm._v(" "),
        _c("div", { staticClass: "content" }, [
          _c("div", {}, [_vm._v(_vm._s(_vm.priceReplyInfo.inqryTitle))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-single" }, [
        _c("div", { staticClass: "title" }, [_vm._v("被询价方")]),
        _vm._v(" "),
        _c("div", { staticClass: "content" }, [
          _c("div", {}, [_vm._v(_vm._s(_vm.priceReplyInfo.merchantName))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-single" }, [
        _c("div", { staticClass: "title" }, [_vm._v("报价时间")]),
        _vm._v(" "),
        _c("div", { staticClass: "content" }, [
          _c("div", {}, [_vm._v(_vm._s(_vm.priceReplyInfo.replyTime))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-single" }, [
        _c("div", { staticClass: "title" }, [_vm._v("要求交付期")]),
        _vm._v(" "),
        _c("div", { staticClass: "content" }, [
          _c("div", {}, [
            _vm._v(_vm._s(_vm.priceReplyInfo.inqryDeliverPeriod) + "  天")
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-single" }, [
        _c("div", { staticClass: "title" }, [_vm._v("交付期")]),
        _vm._v(" "),
        _c("div", { staticClass: "content" }, [
          _c("div", {}, [
            _vm._v(_vm._s(_vm.priceReplyInfo.deliverPeriod) + "  天")
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-single" }, [
        _c("div", { staticClass: "title" }, [_vm._v("联系人")]),
        _vm._v(" "),
        _c("div", { staticClass: "content" }, [
          _c("div", {}, [_vm._v(_vm._s(_vm.priceReplyInfo.contactName))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-single" }, [
        _c("div", { staticClass: "title" }, [_vm._v("联系电话")]),
        _vm._v(" "),
        _c("div", { staticClass: "content" }, [
          _c("div", {}, [_vm._v(_vm._s(_vm.priceReplyInfo.contactTel))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-single" }, [
        _c("div", { staticClass: "title" }, [_vm._v("报价服务")]),
        _vm._v(" "),
        _c("div", { staticClass: "content" }, [
          _c(
            "div",
            { staticClass: "table-layout" },
            [
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.priceReplyInfo.servcList, border: "" }
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "servcImage",
                      width: "150",
                      label: "服务图片",
                      align: "center"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(rows) {
                          return [
                            _c("img", { attrs: { src: rows.row.servcImage } })
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "name", label: "服务名称", align: "center" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "price",
                      label: "市场单价(元)",
                      width: "150",
                      align: "center"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(rows) {
                          return [
                            _c("span", [
                              _vm._v(
                                _vm._s(parseFloat(rows.row.price).toFixed(2))
                              )
                            ])
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "replyPrice",
                      label: "呈报单价(元)",
                      width: "150",
                      align: "center"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(rows) {
                          return [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  parseFloat(rows.row.replyPrice).toFixed(2)
                                )
                              )
                            ])
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-single" }, [
        _c("div", { staticClass: "title" }, [_vm._v("交易规则")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "content" },
          [
            _c("swb-create-trade-rule", {
              ref: "swb_create_trade_rule",
              attrs: {
                comparedTradeRuleList: _vm.comparedTradeRuleList,
                type: _vm.type,
                operate: _vm.tradeOperate,
                forPriceInqry: _vm.forPriceInqry,
                forGoods: _vm.forGoods,
                forServc: _vm.forServc
              }
            })
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("button", { staticClass: "swb-btn swb-btn-link" }, [
      _c("i", { staticClass: "icon iconfont icon-fanhui2 mr5" }),
      _vm._v("返回")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e3fc0610", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e3fc0610","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/priceReply/PriceReplyInfo.vue
// module id = 2081
// module chunks = 1